var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlashcardsSmartTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 53,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m35.422 13.705-.033-.121c-.942-3.516-1.413-5.275-2.457-6.434a6.5 6.5 0 0 0-3.48-2.009c-1.526-.324-3.284.147-6.8 1.089l-7.109 1.905c-3.516.942-5.274 1.413-6.434 2.457a6.5 6.5 0 0 0-2.009 3.48c-.324 1.526.147 3.284 1.09 6.8l4.763 17.779c.888 3.312 1.332 4.969 2.284 6.086a6.5 6.5 0 0 0 3.767 2.174c1.444.267 3.1-.177 6.413-1.065m9.75-23.474-1.952 5.075c-.611 1.588-.917 2.383-1.392 3.05a6.5 6.5 0 0 1-1.53 1.531c-.669.475-1.463.78-3.052 1.392l-5.074 1.952 5.074 1.952c1.589.61 2.383.916 3.052 1.391a6.5 6.5 0 0 1 1.53 1.53c.475.669.78 1.463 1.392 3.052l1.952 5.075 1.951-5.075c.611-1.589.917-2.383 1.392-3.051a6.5 6.5 0 0 1 1.53-1.53c.669-.476 1.463-.781 3.052-1.392l5.075-1.952-5.075-1.952c-1.589-.611-2.383-.917-3.051-1.392a6.5 6.5 0 0 1-1.531-1.53c-.475-.669-.78-1.463-1.392-3.052l-1.951-5.074Z",
  stroke: "url(#flashcards-smart-tool_svg__a)",
  strokeWidth: 4.34,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "flashcards-smart-tool_svg__a",
  x1: 6.998,
  y1: 26.705,
  x2: 48.167,
  y2: 26.705,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#50B354"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#75EA77"
})))));
export default SvgFlashcardsSmartTool;